import { Injectable, Inject } from '@angular/core';
import { EnvironmentProvider } from './browser-providers';
import { Environment } from '../../environments/enviroment.model';
import { Http, RequestOptionsArgs, Headers, Response, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { User } from '../security/user/user.model';

@Injectable()
export class UserService {

  private tokenId = 'jwtToken';
  protected backendUrl: string;
  constructor(
    protected http: Http,
    @Inject(EnvironmentProvider) env: Environment,
  ) {
    this.backendUrl = env.endpoints.api;
  }

  checkNameNotTaken(name: string) {
    return this.http.get(this.buildUrl('/usuarios/existsByName/' + name),
    this.buildRequestOptions(undefined)).map(res => res.json());
  }

  private buildUrl(path: string) {
    return this.backendUrl + encodeURI(path);
  }

  private buildRequestOptions(options: RequestOptionsArgs = {}) {
    options.headers = options.headers || new Headers();
    options.headers.append('Content-Type', 'application/ld+json');
    const token = this.token;
    if (token) {
      options.headers.append('Authorization', 'Bearer ' + token);
    }
    return options;
  }

  get token() {
    return localStorage.getItem(this.tokenId);
  }

  getFotoById(id: number): Observable<Blob> {
    return this.http.get(this.buildUrl('/backend' + User.path + 'foto/' + id),
    this.buildRequestOptions({ responseType: ResponseContentType.Blob }))
    .map((res: Response) => res.blob());
  }
}



// WEBPACK FOOTER //
// ./src/app/core/user.service.ts